<script lang="ts">
  import HubspotForm from '$components/hubspot-form.svelte';
  import Title from '$components/title.svelte';
  import type { ContactFormStoryblok } from '$types/bloks';

  export let blok: ContactFormStoryblok;
  $: ({ anchor_id, title, form } = blok);
</script>

<section id={anchor_id || 'section-contact-form'} class="relative isolate overflow-hidden">
  <div
    class="relative flex w-full flex-col justify-between gap-48 px-20 lg:mx-auto lg:flex-row xl:max-w-container xl:px-48"
  >
    {#if title?.[0]}
      <Title data={title[0]} class="w-full lg:py-48" />
    {/if}

    {#if form}
      <div
        class="mb-48 flex h-fit min-h-[200px] w-full items-center justify-center rounded-4xl border border-foreground border-opacity-4 bg-highlight bg-opacity-8 p-20 text-center text-foreground lg:mb-72 lg:mt-48 lg:max-w-[600px]"
      >
        <HubspotForm form={form.toString()} />
      </div>
    {/if}
  </div>
</section>
